import catalogSlice from './slice';

const catalogReducer = catalogSlice.reducer;

export default catalogReducer;
